import React from 'react';
type SectionProps = {
  /** Legacy section number; no longer rendered. */
  n?: string;
  label: string;
  id?: string;
  /** Extra classes on the row, e.g. "gridpaper" or a page-specific hook. */
  className?: string;
  /** Extra classes on the content column. */
  contentClassName?: string;
  /** Drop the top rule (the first section under the nav). */
  noTop?: boolean;
  children: React.ReactNode;
};

/**
 * The layout unit of the site: a 260px margin column carrying the section
 * label, then the content column. Rows share one horizontal rule.
 */
export function Section({
  label,
  id,
  className,
  contentClassName,
  noTop,
  children
}: SectionProps) {
  const cls = ['sec', noTop ? 'nt' : '', className ?? ''].filter(Boolean).join(' ');
  return <section id={id} className={cls} data-id="element-302" data-mp="7n3wb20ofdkt">
      <div className="sec-m" data-id="element-303" data-mp="vesqknx26c4e">
        <div className="sec-l" data-id="element-304" data-mp="vdhlmkrvmybp">{label}</div>
      </div>
      <div className={['sec-c', contentClassName ?? ''].filter(Boolean).join(' ')} data-id="element-305" data-mp="10595ydkfw7te">{children}</div>
    </section>;
}